import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';

const { pageContentMaxWidthVal, sidebarMenuWidth, sidebarContentWidth } =
  layout;

const pageWithSidebarContent =
  pageContentMaxWidthVal + sidebarMenuWidth.desktop.value * 2;

type SliceProps = {
  sidebarOpen: boolean;
  backgroundColor?: string;
  textColor: string;
  linkColor: string;
};

type SliceContentProps = {
  sidebarOpen: boolean;
};

export const Slice = styled.div<SliceProps>(
  props => css`
    padding: ${layout.measurements.spacing150};
    background-color: ${props.backgroundColor};
    color: ${props.textColor};
    border-left: 1px solid ${props.theme.bg.primary};

    a:not([class]) {
      color: ${props.linkColor};

      &:hover {
        color: ${props.theme.text.callToActionHover};
      }
    }

    ${media.smallOnly`
      padding: ${layout.measurements.spacing150} ${layout.measurements.spacing100};
      border-left: 0;
    `};

    /* Offset to the left behind the invisible sidebar wrapper to keep full width */
    @media screen and (min-width: ${pageWithSidebarContent}px) {
      margin-left: ${props.sidebarOpen
        ? 0
        : `calc(((1250px - 100vw) / 2) + ${sidebarMenuWidth.desktop.rem})`};
    }

    @media screen and (min-width: 1980px) {
      margin-left: ${props.sidebarOpen
        ? 0
        : `calc(-1 * ${layout.sidebarContentWidth.desktop.rem})`};
    }
  `
);

export const SliceContent = styled.div<SliceContentProps>(
  props => css`
    /* Align content with the rest of the page */
    @media screen and (min-width: ${pageWithSidebarContent}px) {
      margin-left: ${props.sidebarOpen
        ? 'inherit'
        : `calc(((100vw - 1250px) / 2) - ${sidebarMenuWidth.desktop.rem})`};
    }

    @media screen and (min-width: 1980px) {
      margin-left: ${props.sidebarOpen
        ? `calc(((100vw - 1250px) / 2) - ${
            sidebarMenuWidth.desktop.value + sidebarContentWidth.desktop.value
          }px)`
        : `calc(((100vw - 1250px) / 2) - ${sidebarMenuWidth.desktop.rem})`};
    }
  `
);
